import { c as _c } from "react/compiler-runtime";
import { MiniChips } from "@website/ui/mini-chips";
import { numberConvert } from "@website/utils/number-convert";
export type AccommodationCardBadgesProperties = {
  list?: Array<{
    title: string;
    description: string;
    color: string;
  }>;
};
export const AccommodationCardBadges: React.FC<AccommodationCardBadgesProperties> = t0 => {
  const $ = _c(4);
  const {
    list
  } = t0;
  let t1;
  if ($[0] !== list) {
    t1 = Boolean(list?.length) && list?.map(_temp);
    $[0] = list;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="no-scrollbar mt-[2px] flex items-center gap-2 overflow-auto">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(badge, index) {
  return <MiniChips key={`${badge.title}-${index}`} text={numberConvert(badge.title, {
    locale: "fa"
  })} textClassName="!text-extra-caption px-1" variant="round-accent" />;
}